// extracted by mini-css-extract-plugin
module.exports = {"root":"invite_root__1mHIa","name":"invite_name__3MW8z","acceptBtn":"invite_acceptBtn__xqTEC"};